export default __webpack_public_path__ + "static/media/webbing2.0f290c1e.png";